export default function initIconContentList() {
    // ==========================================================
    // ICON CONTENT LIST
    // ==========================================================

    const iconContentLists = document.querySelectorAll("[data-icon-content-list]");

    iconContentLists.forEach((list) => {
        const triggers = list.querySelectorAll("[data-icon-content-trigger]");

        triggers.forEach((trigger) => {
            trigger.addEventListener("click", () => {
                const item = trigger.closest(".icon-content-list__item");

                const panel = item?.querySelector("[data-icon-content-panel]");

                if (!item || !panel) {
                    return;
                }

                const isOpen = trigger.getAttribute("aria-expanded") === "true";

                trigger.setAttribute("aria-expanded", isOpen ? "false" : "true");

                panel.hidden = isOpen;

                item.classList.toggle("is-open", !isOpen);
            });
        });
    });
}
